import React from "react";
import FormatedDate from "./FormatedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <div className="currentWeatherBlock">
        <div className="row">
          <div className="col-4">
            <h1>{props.data.city}</h1>
            <ul>
              <li>
                <FormatedDate date={props.data.date} />
              </li>
              <li className="text-capitalize">{props.data.description}</li>
            </ul>
          </div>
          <div className="col-8">
            <div className="row">
              <div className="col-4">
                High <br /> {Math.round(props.data.highTemperature)}°C
              </div>
              <div className="col-4">
                Wind <br /> {Math.round(props.data.wind)}km/h
              </div>
              <div className="col-4">
                Humidity <br /> {Math.round(props.data.humidity)}%
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <div className="clearfix">
              <div className="float-left">
                <WeatherIcon code={props.data.icon} size={52} />
              </div>

              <div className="float-left">
                <WeatherTemperature celsius={props.data.temperature} />
              </div>
            </div>
          </div>
          <div className="col-8">
            <div className="row">
              <div className="col-4">
                Low <br /> {Math.round(props.data.lowTemperature)}°C
              </div>
              <div className="col-4">
                Feels like <br /> {Math.round(props.data.feelsLike)}°C
              </div>
              <div className="col-4">
                Pressure <br /> {Math.round(props.data.pressure)} inHg
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
